import axios from "axios";
import forge from "node-forge";
import { mockedTokensIcons } from "../components/mockedData";

export const formatLargeText = (text, maxLength = 60) => {
  if (!text) return;

  if (text.length > maxLength) {
    return text.slice(0, 8) + "..." + text.slice(-4);
  }

  return text;
};

export function copyToClipboard(text) {
  navigator.clipboard.writeText(text);
}

export function formatDate(date) {
  return new Date(date).toLocaleString();
}

export function validateEmail(email) {
  const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return regexEmail.test(email);
}

export function formatTimeUnix(unixTimestamp) {
  if (!unixTimestamp) return "-";

  const date = new Date(unixTimestamp * 1000);
  return date.toLocaleString(undefined, {
    timeZoneName: "short",
  });
}

export async function getToken() {
  const encryptedUsername = encryptText("develone");
  const encryptedPassword = encryptText("develonepwd");

  try {
    var data = JSON.stringify({
      user: encryptedUsername,
      password: encryptedPassword,
    });

    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_CORE_TENUI_URL}/token`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };

    const response = await axios(config);
    localStorage.setItem("tokenContraPago", response.data.token);
    return true;
  } catch (error) {
    return false;
  }
}

export function truncateWithEllipsis(str, maxLength, ellipsis = "...") {
  if (typeof str !== "string") return str;
  if (str.length <= maxLength) return str;
  return str.slice(0, maxLength) + ellipsis;
}

export function getTokenIcon(tokenName) {
  return mockedTokensIcons.find((token) => token.name === tokenName)?.logo;
}

export function encryptText(text) {
  const publicKeyPem = `-----BEGIN PUBLIC KEY-----\n${process.env.REACT_APP_PUBLIC_KEY.match(
    /.{1,64}/g
  ).join("\n")}\n-----END PUBLIC KEY-----`;
  const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

  const encryptedBytesText = publicKey.encrypt(text, "RSA-OAEP", {
    md: forge.md.sha256.create(),
  });
  const encryptedText = forge.util.encode64(encryptedBytesText);

  return encryptedText;
}

export function validateExcelFile(file) {
  if (!file) return false;

  const allowedExtensions = ["xlsx", "xls"];
  const fileExtension = file.name.split(".").pop().toLowerCase();

  return allowedExtensions.includes(fileExtension);
}
